import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DeviceIndicatorState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: DeviceIndicatorState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const addDeviceIndicatorSlice = createSlice({
  name: 'AddDeviceIndicatorSlice',
  initialState,
  reducers: {
    addDeviceIndicatorLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    addDeviceIndicatorUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    addDeviceIndicatorErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  addDeviceIndicatorLoadingAction,
  addDeviceIndicatorUpdateAction,
  addDeviceIndicatorErrorAction
} = addDeviceIndicatorSlice.actions

export default addDeviceIndicatorSlice.reducer
